//
// Copyright 2024 DXOS.org
//

/**
 * Explicitly marks signal dependencies for tracking within effects.
 * Returns the passed value to enable inline usage.
 */
export const touch = <T>(value: T) => value;
